import { getChronicPathologies } from "../../../services/PathologyService";
import useResources from "../../../hooks/UseResources";

export default function usePathologies() {
    return useResources(getChronicPathologies, "data");
}
